export const setStepData = (step) => ({
    type: 'SET_STEP_DATA',
    payload: { step },
});

export const setCurrentMembership = (currentMembership) => ({
    type: 'SET_CURRENT_MEMBERSHIP',
    payload: { currentMembership },
});

export const setProcessData = (data) => ({
    type: 'SET_PROCESS_DATA',
    payload: { data },
});

export const clearProcessData = () => ({
    type: 'CLEAR_PROCESS_DATA',
});